import Auth from "../routes/Auth";
import get from "lodash/get";
import EventEmitter from "./event-emitter";

class Analytics {
  static event(round_number, window, pathname) {
    const url = get(window, 'location.href', null);
    if (url && Auth.getPosition() === "Student") {
      const eventEmitter = EventEmitter.getInstance();
      eventEmitter.trigger("analytics-event", [
        round_number,
        url,
        Auth.getUserId(),
        Auth.getGameId(),
        Auth.getCourseId(),
        pathname,
      ]);
    }
  }
}

export default Analytics;



// WEBPACK FOOTER //
// ./src/services/analytics.js